const COMPARE_WORDS = {
    gt: "must be greater than",
    gte: "must be at least",
    lt: "must be less than",
    lte: "must be at most",
    eq: "must equal",
    ne: "must not equal",
};
export function describeValidateRuleConfig(rule) {
    switch (rule.type) {
        case "required":
            return "must not be blank";
        case "compare": {
            if (!rule.op)
                return undefined;
            const words = COMPARE_WORDS[rule.op];
            const target = typeof rule.value === "number" ? rule.value : Number(rule.value);
            if (!words || Number.isNaN(target))
                return undefined;
            return `${words} ${target}`;
        }
        case "length": {
            const min = typeof rule.min === "number" ? rule.min : undefined;
            const max = typeof rule.max === "number" ? rule.max : undefined;
            if (min !== undefined && max !== undefined)
                return `must be ${min}–${max} characters`;
            if (min !== undefined)
                return `must be at least ${min} characters`;
            if (max !== undefined)
                return `must be at most ${max} characters`;
            return undefined;
        }
        case "oneOf": {
            const values = Array.isArray(rule.values) ? rule.values : [];
            if (values.length === 0)
                return undefined;
            return `must be one of ${values.join(", ")}`;
        }
        case "pattern":
            return rule.pattern ? `must match ${rule.pattern}` : undefined;
        default:
            // custom (expression-evaluated elsewhere) and unknown types have no
            // param-derivable phrasing.
            return undefined;
    }
}
//# sourceMappingURL=describe-validate-config.js.map